import { useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";

interface UnwatchTripFooterProps {
  cn: (elementName: string) => string;
  isSubmitting: boolean;
}

export const UnwatchTripFooter = ({
  cn,
  isSubmitting,
}: UnwatchTripFooterProps): JSX.Element => {
  const { t } = useI18nContext();

  return (
    <button
      className={clsx(cn("cta-button"), "cta-button")}
      type="submit"
      form="unwatch-trip-form"
      disabled={isSubmitting}
    >
      {t("priceWatch.stopWatchingButtonCta")}
    </button>
  );
};
